"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon20Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon20Light = forwardRef_1.forwardRef('PlusIcon20Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M9.5 1.917a.5.5 0 0 1 .5.5V9h6.583a.5.5 0 1 1 0 1H10v6.584a.5.5 0 1 1-1 0V10H2.417a.5.5 0 0 1 0-1H9V2.417a.5.5 0 0 1 .5-.5Z" })));
});
